import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Investor } from "../../types/Investor";
import { getInvestors, getInvestorById } from "@/api";

interface UseInvestorsController {
  investors: Investor[];
  filteredInvestors: Investor[];
  isLoading: boolean;
  error: unknown;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  refresh: () => void;
}

export const useInvestorsController = (): UseInvestorsController => {
  const [searchQuery, setSearchQuery] = useState("");

  const {
    data: investors = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["investors"],
    queryFn: async () => {
      const investors = await getInvestors();
      return investors;
    },
  });

  const refresh = () => {
    refetch();
  };

  const filteredInvestors = useMemo(() => {
    if (!investors) return [];

    if ((searchQuery ?? "").trim() !== "") {
      return investors.filter((investor) =>
        investor.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    return investors;
  }, [searchQuery, investors]);

  return {
    investors,
    filteredInvestors,
    isLoading,
    error,
    searchQuery,
    setSearchQuery,
    refresh,
  };
};
